// deps
import { AriaHidden } from "@swiggy-private/core-ui";
import { getCornerRadius } from "@swiggy-private/dls-web-common/dist/components/themes/CornerRadiusMapping/mapping";
import styled, { css } from "styled-components";

const textAreaHeight = "56px";

// base styles
const buttonResetStyles = css`
    background: transparent;
    border: none;
    outline: none;
    padding: 0;
    text-align: left;
    appearance: none;
    -webkit-appearance: none;
`;

export const ButtonStyled = styled.button<{ isActive: boolean }>`
    ${buttonResetStyles}
    color: ${props => props.theme.colors[props.theme.colorMode].text_Med_Emphasis};
    padding: ${props => props.theme.spacing.xSmall} ${props => props.theme.spacing.small} ${props =>
    props.theme.spacing.xSmall} ${props => props.theme.spacing.xSmall};
    display: flex;
    border: 1px solid ${props => props.theme.colors[props.theme.colorMode].divider};
    border-radius: ${props => getCornerRadius(props.theme, "xSmall")};


    ${props =>
        props.isActive &&
        css`
            color: ${props => props.theme.colors[props.theme.colorMode].text_High_Emphasis};
            border-color: ${props => props.theme.colors[props.theme.colorMode].divider};
            background-color: ${props => props.theme.colors[props.theme.colorMode].background_Secondary};
            padding-right: ${props => props.theme.spacing.xSmall};
        `}
`;

export const StartIconStyled = styled(AriaHidden)`
    margin-right: ${props => props.theme.spacing.xxSmall};
`;

export const EndIconStyled = styled(AriaHidden)`
    margin-left: ${props => props.theme.spacing.xxSmall};
`;

export const TextareaContainerStyled = styled.div`
    background: ${props => props.theme.colors[props.theme.colorMode].background_Primary};
    padding: 0 ${props => props.theme.spacing.large} 0;
    margin-top: ${props => `calc(${props.theme.spacing.large} * -1)`};
    transition: margin-top 0.2s ease-in-out;
`;

export const TextareaContentStyled = styled.div`
    height: ${textAreaHeight};
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    opacity: 1;
    transition: opacity 0.2s ease-in-out;
`;

export const TextareaStyled = styled.textarea`
    ${props => props.theme.typography["V2.body2.neutral.regular"]}
    width: 100%;
    min-height: 17px;
    outline: 0;
    resize: none;
    overflow: auto;
    caret-color: ${props => props.theme.colors[props.theme.colorMode].primary};
    color: ${props => props.theme.colors[props.theme.colorMode].text_High_Emphasis};
    border: 0;

    &::placeholder {
        ${props => props.theme.typography["V2.body2.neutral.regular"]}
        color: ${props => props.theme.colors[props.theme.colorMode].text_Med_Emphasis};
        opacity: 1;
        word-wrap: break-word;
        white-space: pre-line;
        overflow: hidden;
    }

    &::-ms-input-placeholder {
        color: ${props => props.theme.colors[props.theme.colorMode].text_Med_Emphasis};
        ${props => props.theme.typography["V2.body2.neutral.regular"]}
    }

    &:focus {
        &::placeholder {
            color: ${props => props.theme.colors[props.theme.colorMode].text_Low_Emphasis};
        }

        &::-ms-input-placeholder {
            color: ${props => props.theme.colors[props.theme.colorMode].text_Low_Emphasis};
        }
    }
`;

export const InstructionsTitleStyled = styled.span`
    ${props => props.theme.typography["V2.body3.neutral.medium"]}
    color: ${props => props.theme.colors[props.theme.colorMode].text_Med_Emphasis};
`;

export const InstructionsContentStyled = styled.span`
    ${props => props.theme.typography["V2.body3.neutral.regular"]}
    color: ${props => props.theme.colors[props.theme.colorMode].text_Low_Emphasis};
`;

export const NoteStyled = styled.div`
    padding: 0px 0px ${props => props.theme.spacing.medium} ${props => props.theme.spacing.xSmall};
    margin: 0 ${props => props.theme.spacing.small} 0;
    width: 100%;
`;
export const StyledResizeWrapper = styled.div<{ textAreaActive: boolean }>`
    width: 100%;
    overflow: hidden;
`;

export const InstructionTextContainer = styled.div`
    margin-top: 1px;
`;
